export default "<app-inner-layout>\r\n  <p [@rightSlideIn]=\"viewportService.pageReady\">\r\n    about works!\r\n  </p>\r\n</app-inner-layout>\r\n"